import * as Sentry from "@sentry/browser";
import { Angular as AngularIntegration } from "@sentry/integrations";
import angular from 'angular';
import { environment } from '../../environments/environment';

function ignoreIfMessage(event, hint, messages) {
  return messages.some(message =>
    ((event.exception?.values || [])[0]?.value || '').indexOf(message) > -1 ||
    hint.originalException && (
      (hint.originalException['message'] || '').indexOf(message) > -1 ||
      (hint.originalException.error?.error?.message || '').indexOf(message) > -1)
  )

}
const messagesToIgnore = [
  'Non-Error exception captured',
  'Object captured as exception with keys',
  'Permission denied to access property "nodeType"',
  `The fetching process for the media resource was aborted by the user agent at the user's request.`,
  'In this configuration Angular requires Zone.js',
  'Failed to fetch',
  'Illegal invocation',
  'curOp is null',
  `Cannot read properties of undefined (reading 'isProxied')`,
  'The operation was aborted.',
  `Cannot read properties of null (reading 'getClientRects')`,
  `Failed to execute 'setEnd' on 'Range'`,
  'Loading chunk '
];

// regex to exclude urls from stack trace
const urlsToIgnore = [
  /track(-dev[\d])?\.alcmeon\.com\/track\//
];

export function sentryRun() {
  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [
      new AngularIntegration({ angular: angular }),
      Sentry.browserTracingIntegration(),
    ],

    beforeBreadcrumb(breadcrumb) {
      if(breadcrumb.category === 'xhr' && urlsToIgnore.some(regex => regex.test(breadcrumb.data?.url))) {
        return null;
      }

      return breadcrumb;
    },

    beforeSend(event, hint) {
      let isNonErrorException;
      try {
        /* tslint:disable:no-string-literal only-arrow-functions */
        isNonErrorException = ignoreIfMessage(event, hint, messagesToIgnore
        );
      } catch {
        return event;
      }
      if (isNonErrorException) {
        // We want to ignore those kind of errors
        return null;
      }

      const exception = hint.originalException;
      // Prevent to group by using existing fingerprint.
      if (exception?.originalStack?.includes && exception.originalStack.includes('Internal server error (500)')) {
        event.fingerprint = [`${new Date().getTime()}`];
      }
      return event;
    }
  });
}
